import {
  EstablishmentActions,
  EstablishmentActionTypes,
} from '../actions/establishment.actions';

export interface EstablishmentState {
  data: RascunhoAnaliseResponseRecord | null;
  loading: boolean;
  error: any;
}

export const initialState: EstablishmentState = {
  data: null,
  loading: false,
  error: null,
};

export function reducer(
  state = initialState,
  action: EstablishmentActions
): EstablishmentState {
  switch (action.type) {
    case EstablishmentActionTypes.LOAD_ESTABLISHMENT:
      return { ...state, loading: true };
    case EstablishmentActionTypes.LOAD_ESTABLISHMENT_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case EstablishmentActionTypes.LOAD_ESTABLISHMENT_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case EstablishmentActionTypes.LOAD_ESTABLISHMENT_CLEAR:
      return initialState;
    default:
      return state;
  }
}

export const selectData = (state: EstablishmentState) => state.data;
